module.exports = __webpack_public_path__ + "img/video.16975708.svg";